import { render, staticRenderFns } from "./ConfigurationDesign.vue?vue&type=template&id=213f31f2&scoped=true&"
import script from "./ConfigurationDesign.vue?vue&type=script&lang=js&"
export * from "./ConfigurationDesign.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationDesign.vue?vue&type=style&index=0&id=213f31f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213f31f2",
  null
  
)

export default component.exports